import { createFileRoute, Link } from '@tanstack/react-router';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { CardGenerator } from '../../components/cards/card-generator/CardGenerator';
import {
  type CardsSearchPatch,
  cardsSearchSchema,
} from '../../components/cards/cards-url-state';

export const Route = createFileRoute('/_auth/cards')({
  validateSearch: cardsSearchSchema,
  component: CardsPage,
});

function CardsPage() {
  const { t } = useTranslation();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  // Mirror the form into the URL so a filled form can be bookmarked/shared.
  // `replace` keeps typing from flooding the browser history; `resetScroll`
  // off because this is state mirroring, not a page change — the default
  // scroll-to-top would yank the user away from the field they are typing in.
  const patchSearch = useCallback(
    (patch: CardsSearchPatch) => {
      void navigate({
        search: (prev) => ({ ...prev, ...patch }),
        replace: true,
        resetScroll: false,
      });
    },
    [navigate],
  );

  return (
    <div>
      <Link to="/" className="btn-link mb-6">
        {t('nav.backToHub')}
      </Link>
      <header className="section-head">
        <div>
          <p className="label dash">{t('cards.subheader')}</p>
          <h1 className="display mt-2 text-3xl md:text-5xl">
            {t('cards.header')}
          </h1>
        </div>
        <p className="label">{t('cards.meta')}</p>
      </header>

      <CardGenerator search={search} onSearchPatch={patchSearch} />
    </div>
  );
}
